import ExhibitorCategoryContainer from "components/exhibitorCategory/ExhibitorCategoryContainer";

export default function ExhibitorCategoryPage() {
  return <ExhibitorCategoryContainer />;
}
